import { render, staticRenderFns } from "./OtherSignerUpdate.vue?vue&type=template&id=51be5db8"
import script from "./OtherSignerUpdate.vue?vue&type=script&lang=js"
export * from "./OtherSignerUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports